import { StateCreator } from 'zustand'

const alertDialogInitialState = {
  header: '',
  open: false,
  message: '',
}

export interface AlertDialogSlice {
  alertDialog: typeof alertDialogInitialState
  setAlertDialog: (payload: typeof alertDialogInitialState) => void
}

const createAlertDialogSlice: StateCreator<AlertDialogSlice> = (set) => ({
  alertDialog: alertDialogInitialState,
  setAlertDialog: (payload) => {
    set(() => ({
      alertDialog: payload,
    }))
  },
})

export default createAlertDialogSlice
